export enum AttendanceStatus {
  Absent = "ABSENT",
  Present = "PRESENT",
  AbsentNotified = "ABSENT_NOTIFIED",
  AbsentNotifiedShort = "T",
  InterruptedNotified = "INTERRUPTED_NOTIFIED",
  InterruptedNotifiedShort = "K",
}
